import { connect, ConnectedProps } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import actions from '../../../state/actions';

const mapDispatch = (dispatch: ThunkDispatch<{}, {}, AnyAction>) => ({
  onLoad() {
    dispatch(actions.watchers.fetchUserWatchers());
  },
});

export const Connect = connect(null, mapDispatch);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
